/**
 * @description Composable to check if the user has access to a specific property of a site.
 * @param {keyof ISite} property - The property to check access for.
 * @param {Store} store - The Vuex store instance (optional, defaults to useStore).
 * @returns {boolean} - Returns true if the user has access to the specified property, false otherwise.
 */
import { computed } from 'vue';
import { useStore } from 'vuex';

import { ISite } from '@/Core.Service.Domain/ViewSupport/Portfolio/types/Site';
import type { Store } from 'vuex';

interface PortfolioStoreGetters {
  'ViewSupportStore/PortfolioStore/getPortfolioSitesList': Partial<ISite>[];
}

export function useUserHasAccessTo(
  property: keyof ISite,
  store?: Store<unknown> & { getters: PortfolioStoreGetters }
): boolean {
  if (!store) {
    store = useStore() as Store<unknown> & { getters: PortfolioStoreGetters };
  }
  const userPortfolioList = computed<Partial<ISite>[]>(
    () => store.getters['ViewSupportStore/PortfolioStore/getPortfolioSitesList']
  );

  return userPortfolioList.value.some((site: Partial<ISite>) =>
    Boolean(site[property])
  );
}
